var BaseViews = require('../../../base');

require('./menu-item-price/menu-item-price.scss');
var LAYOUT_TYPES = {
    STACKED: 'stacked',
    INLINE: 'inline',
    PROMOTION: 'promotion'
};
var MenuItemPrice = BaseViews.ItemView.extend({
    className: 'fmcy-menu-item-price',
    template: function (serializedData) {
        if (serializedData.options.layout === LAYOUT_TYPES.PROMOTION) {
            return require('./menu-item-price/menu-item-price-promotion.html')(serializedData);
        } else {
            return require('./menu-item-price/menu-item-price.html')(serializedData);
        }
    },
    ui: {
        addedIndicator: '.fmcy-menu-item-price-added',
        priceQuantity: '.fmcy-menu-item-price-quantity',
        buyButton: '.fmcy-menu-item-price-buy-button'
    },
    triggers: function () {
        return {
            'click': {
                event: 'price:clicked',
                stopPropagation: this.options.onlinePurchaseEnabled
            },
            'mouseover': {
                event: 'price:mouseover',
                stopPropagation: true
            }
        };
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                onlinePurchaseEnabled: false,
                hideOutOfStockVariation: true,
                layout: LAYOUT_TYPES.STACKED // stacked | inline | promotion
            }
        );
    },
    displayAddedAnimation: function() {
      var self = this;
        this.ui.addedIndicator.show();
        window.gsap.fromTo(this.ui.addedIndicator,
        {
          opacity: 1,
          top: '0px'
        },
        {
          opacity: 0,
          top: '-50',
          duration: 1
        });
    },
    _isOnSale: function () {

      if (this.model.get('sale_price') === "0.00") {
        return false;
      } else {
        return !!this.model.get('sale_price') && this.model.get('on_sale');
      }
    },
    serializeData: function() {
        var onSale = this._isOnSale();
        var price = this.model.get(onSale ? 'sale_price' : 'price');
        var regularPrice = this.model.get(onSale ? 'price' : 'sale_price');
        return {
            options: this.options,
            quantity: this.model.get('quantity'),
            regularPrice: regularPrice,
            price: price,
            onSale: onSale,
            saved: onSale ? (regularPrice - price).toFixed(2) : ''
        };
    },
    onRender: function () {
        if (this.options.onlinePurchaseEnabled) {
            this.$el.addClass('fmcy-online-purchase-enabled');
        } else {
          this.ui.buyButton.hide();
        }
        if (this._isOnSale()) {
            this.$el.addClass('fmcy-on-sale');
        }
        if (this.model.get('quantity') === '1') {
          this.ui.priceQuantity.hide();
        }

        if (this.options.variantOutOfStockAtFilteredLocation === true) {
          if (this.options.hideOutOfStockVariation === true) {
            this.$el.hide();
          } else {
            this.$el.addClass('fmcy-disable-mouse-event');
            this.ui.buyButton.css('opacity', 0.10);
            this.$el.css('cursor', 'default');
          }
        }
        this.$el.addClass('fmcy-menu-item-price-layout-' + this.options.layout);

        BaseViews.ItemView.prototype.onRender.call(this);
    }
});
module.exports = MenuItemPrice;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/menu-item-prices/menu-item-price.js
 **/